import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

const searchTranslationRef = createTranslationRef({
  id: "search",
  messages: {
    searchModal: {
      viewFullResults: "View Full Results"
    },
    searchType: {
      allResults: "All Results",
      tabs: {
        allTitle: "All"
      },
      accordion: {
        allTitle: "All",
        collapse: "Collapse",
        numberOfResults: "{{number}} results"
      }
    },
    sidebarSearchModal: {
      title: "Search"
    }
  }
});

export { searchTranslationRef };
//# sourceMappingURL=translation.esm.js.map
